import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "@angular/common";
const _c0 = a0 => ({ current: a0 });
export class DarkmodePreferenceComponent {
    constructor(accountsService) {
        this.accountsService = accountsService;
        this.darkMode = false;
    }
    ngOnInit() {
        this.accountsService.getUserPreferences().subscribe((preference) => {
            this.darkMode = preference.dark_mode;
        });
    }
    setDarkMode(darkMode) {
        this.accountsService.putUserPreferences({ dark_mode: darkMode }).subscribe(() => {
            window.location.reload();
        });
    }
}
DarkmodePreferenceComponent.ɵfac = function DarkmodePreferenceComponent_Factory(t) { return new (t || DarkmodePreferenceComponent)(i0.ɵɵdirectiveInject(i1.AccountsService)); };
DarkmodePreferenceComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DarkmodePreferenceComponent, selectors: [["ycn-dark-mode-preference"]], decls: 5, vars: 6, consts: [[1, "btn-group", "switch"], ["data-test-id", "dark-mode-off", 1, "btn", "btn-off", 3, "click", "ngClass"], ["data-test-id", "dark-mode-on", 1, "btn", "btn-on", 3, "click", "ngClass"]], template: function DarkmodePreferenceComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        i0.ɵɵlistener("click", function DarkmodePreferenceComponent_Template_button_click_1_listener() { return ctx.setDarkMode(false); });
        i0.ɵɵtext(2, "Off");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "button", 2);
        i0.ɵɵlistener("click", function DarkmodePreferenceComponent_Template_button_click_3_listener() { return ctx.setDarkMode(true); });
        i0.ɵɵtext(4, "On ");
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, !ctx.darkMode));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, ctx.darkMode));
    } }, dependencies: [i2.NgClass], encapsulation: 2 });
